import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Divider } from '@kambi/spark';

import classes from '../../App.module.css';
import SystemCombinationsDescription from 'components/system-combinations/description/SystemCombinationsDescription';
import CodeBlock from 'components/layout/code-block/CodeBlock';
import SystemCombinationsExample from 'components/system-combinations/jsonExamples/SystemCombinations';
import TestBlock from 'components/layout/test-block/TestBlock';
import { UtilsTypes } from 'constants/utilsTypes';
import { Schemas } from '@kambi/betting-client-helpers';
import TabsBlock from 'components/layout/tabs-block/TabsBlock';

const SystemCombinations = () => {
    const navigate = useNavigate();
    return (
        <div className={classes.Wrapper}>
            <Button
                color="primary"
                variant="outlined"
                onClick={() => navigate('/')}
            >
                Back
            </Button>
            <div className={classes.Divider}>
                <Divider />
                <div className={classes.Content}>
                    <div className={classes.Title}>System combinations</div>
                    <div className={classes.Main}>
                        <SystemCombinationsDescription />
                        <Divider />
                        <CodeBlock {...SystemCombinationsExample} />
                        <TabsBlock
                            title="System combinations parameters"
                            type={UtilsTypes.SYSTEM_COMBINATIONS}
                        />
                        <TestBlock
                            validationSchema={
                                Schemas.SystemCombinationsParamsTypeSchema
                            }
                            title="You can test the getSystemCombinations() function by adding the input parameters as
                a JSON object in the below textarea, click Run and check the
                Output in the right"
                            type={UtilsTypes.SYSTEM_COMBINATIONS}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SystemCombinations;
